<template>
    <div class="w-20 text-black text-left mt-10 cursor-pointer" @click="type === 'custom' ? goRoute() : backHistory()">
        <fa icon="angle-left" /> Anterior
    </div>
</template>

<script lang="ts">

export default {
  name: 'Back',
  props: {
    data_alert: { type: Object, required: true, default() {
    return{
        title: "",
        msg: "",
        description: "",
        type: "",
        open: true
        }
    }},
    type: { type: String, required: true, default: '' },
  },
  emits: ['onFire'],
  setup (props: any, { emit } : any) {

    const closeAlert = () => {
      if(props.data_alert.open == true){
        emit("onFire")
      }
      
    }

    const backHistory = () => {
      window.history.back()
    }

    const goRoute = async () => {
      emit("onFire");
    }

    return {
      closeAlert,
      backHistory,
      goRoute
    }

  }
}

</script>
